import MapSummary from './MapSummary';

export default MapSummary;
